<template>
  <expandable header="Injuries" class="mb-10">
    <b-row>
      <b-col cols="12" md="4">
        <yes-no
          v-model="form.chest_injuries"
          label="Chest Injuries"
          rules="required"
          :disabled="isDisabled"
          @input="onInput"
        ></yes-no>
      </b-col>
      <b-col cols="12" md="4">
        <yes-no
          v-model="form.abdomen_injuries"
          @input="onInput"
          label="Abdomen Injuries"
          :disabled="isDisabled"
          rules="required"
        ></yes-no>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.notes"
          @input="onInput"
          label="Notes"
          :disabled="isDisabled"
        ></input-field>
      </b-col>
    </b-row>
  </expandable>
</template>

<script>
import Expandable from "../../Expandable.vue";
import YesNo from "../../form/YesNo.vue";
export default {
  components: { YesNo, Expandable },
  props: {
    value: {},
    isDisabled: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    onInput() {
      this.$emit("input", this.form);
    },
  },
  beforeMount() {
    this.form = this.value;
  },
};
</script>

<style></style>
